import apiFetch from '../../apiFetch'

export default function (token, cityId) {
  const queryParamsArray = [
    `cityId=${cityId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `Entity/GetAllTowns${queryParams}`, method: 'GET', token: token })
}
